var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
export class AspectDraggable {
    parent;
    isDragging = false;
    latestDragEvent;
    runtimePosition;
    latestDragStart;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    get defaultPosition() {
        return {
            x: this.aspect.scaledValueOf.draggableDefaultX,
            y: this.aspect.scaledValueOf.draggableDefaultY,
        };
    }
    get definedPosition() {
        if (this.runtimePosition)
            return this.runtimePosition;
        if (!this.aspect.activeOf.draggableX)
            return undefined;
        return {
            x: this.aspect.scaledValueOf.draggableX,
            y: this.aspect.scaledValueOf.draggableY,
        };
    }
}
__decorate([
    observable
], AspectDraggable.prototype, "isDragging", void 0);
__decorate([
    observable.ref
], AspectDraggable.prototype, "latestDragEvent", void 0);
__decorate([
    observable.ref
], AspectDraggable.prototype, "runtimePosition", void 0);
__decorate([
    observable.ref
], AspectDraggable.prototype, "latestDragStart", void 0);
